import { SimpleButton } from './common/SimpleButton';
import { UtilFunc } from './common/UtilFunc';
import { DialogController } from './common/DialogController';
import { GameMain } from "./common/GameMain";
import { GameQuizResources } from './GameQuizResources';
import { GameQuizTitleView } from './GameQuizTitle';
import { GameQuizGameView } from './GameQuizView';
import { GameApi } from './common/GameApi';
import { ManifestLoader } from './common/ManifestLoader';

export class GameQuizMain extends GameMain {
    static stageWidth: number = 750;
    static stageHeight: number = 1200;

    static GAME_ID = 1;
    static BORDER_SCORE = 18000;
    static api: GameApi;
    static eventTagGameEnd: string = "scoredialog";
    static eventTagRaikInDialogClosed: string = "rankindialogclosed";
    static eventTagScoreDialogClosed: string = "scoredialogclosed";
    static eventTagApplicationDialogClosed: string = "applicationdialogclosed"
    static eventTagApplication: string = "application";
    
    protected titleView: GameQuizTitleView;
    protected GameView: GameQuizGameView;
    protected replayButton: SimpleButton;
    protected resources: GameQuizResources;

    static BannerContainer: createjs.Container;
    static BannerList : Array<BannerList>;

    static isDebug = false;
    
    static selectGame:number = 0;
    static SELECT_GAMETYPE_ONCE:number = 0;
    static SELECT_GAMETYPE_FAMILY:number = 1;

    constructor(canvasId: string) {
        super(canvasId);
        const canvas = <HTMLCanvasElement>document.getElementById(canvasId);
        UtilFunc.resizeCanvas(canvas, GameQuizMain.stageWidth, GameQuizMain.stageHeight);
    }
    /**
     * クラスの初期化
     * リソース読み込みなどもここ
     */
    protected async initClass(): Promise<void> {
        this.setParam();

        //リソースの読み込み
        this.resources = new GameQuizResources();
        this.resources.settings = [
            {
                id: "game",
                srcImage: "asset/asset_game.png",
                srcJson: "asset/asset_game.json"
            }
        ];
        //
        for(let j=0; j<Object.keys(this.resources.SingleImageList).length; j++) {
            this.resources.settings.push(
                {id: this.resources.SingleImageList[j].id, srcImage:this.resources.SingleImageList[j].srcImage}
            );
        };
        await this.resources.loadManifest();
        // ローカルストレージ管理
        //this.resources.initStorage();

        //タイトル画面の作成
        this.titleView = new GameQuizTitleView(GameQuizMain.stageWidth, GameQuizMain.stageHeight, this.resources);
        await this.titleView.initClass();
        await this.titleView.initScenes();
        this.contentsLayer.addChild(this.titleView);
        //スタートボタン押下
        this.addEventListener(GameQuizTitleView.eventTagStart, () => {
            this.gotoMenu();
        })

        // ゲーム画面の作成
        this.GameView = new GameQuizGameView(GameQuizMain.stageWidth, GameQuizMain.stageHeight, this.resources);
        await this.GameView.initClass();
        this.contentsLayer.addChild(this.GameView);
        this.addEventListener(GameQuizGameView.eventTagBack, () => {
            this.gotoTitle();
        })

        //スタートボタン押下
        this.addEventListener(GameQuizTitleView.eventTagStartGame, (e:createjs.Event) => {
            //console.log(e.target.selectGame);
            this.startGame(e.target.selectGame);
        })
    
        createjs.Ticker.timingMode = createjs.Ticker.RAF;
        //createjs.Ticker.framerate = 60;

        // バナーまわり
        //let BannerMask = new createjs.Shape();
        //BannerMask.graphics.beginFill("#000").drawRect(0, this.height-160, this.width, 160);
        //BannerMask.alpha = 0.5;
        //this.addChild(BannerMask);
        
        GameQuizMain.BannerContainer = new createjs.Container();
        GameQuizMain.BannerContainer.setBounds(0, 0, this.width, this.height);
        GameQuizMain.BannerContainer.alpha = 1;
        this.addChild(GameQuizMain.BannerContainer);
   
        GameQuizMain.BannerList = [
            {img:new createjs.Sprite(this.resources.settings["background"]), file:"get_banner1"},
            {img:new createjs.Sprite(this.resources.settings["background"]), file:"get_banner2"},
            {img:new createjs.Sprite(this.resources.settings["background"]), file:"get_banner3"}
        ];
        
        for(let i=0; i<GameQuizMain.BannerList.length; i++) {
            GameQuizMain.BannerList[i].img = this.resources[ GameQuizMain.BannerList[i].file ]();

            GameQuizMain.BannerList[i].img.x = (GameQuizMain.stageWidth/2)-(750/2);
            GameQuizMain.BannerList[i].img.y = (GameQuizMain.stageHeight-(60*2));
            GameQuizMain.BannerList[i].img.scaleX = 2;
            GameQuizMain.BannerList[i].img.scaleY = 2;
            GameQuizMain.BannerList[i].img.visible = false;
            GameQuizMain.BannerContainer.addChild( GameQuizMain.BannerList[i].img );
        }

        GameQuizMain.setBanner(0);

        // 問題文
        this.resources.LoadingText();
        
        // 音声
        const Soundloader = new ManifestLoader(
                this.resources.soundfile
        );
        Soundloader.load();
        GameQuizMain.isDebug = DebugFlag();
    }

    /**
     * コンテンツの作成
     *
     * @param parent
     */
    protected async createContents(parent: createjs.Container): Promise<void> {

    }

    /**
     * 作成したコンテンツ等の初期化
     */
    protected async initContents(): Promise<void> {
        this.viewset();
        this.gotoTitle();
    }

    /**
     * ゲームの初期化
     */
    protected async initGame() {

       
    }

    /**
     * ゲームスタート
     */
    protected async startGame(selectGame) {
        this.viewset();
        this.GameView.visible = true;
        GameQuizMain.selectGame = selectGame;
        this.GameView.initScenes();
    }
    /**
     * タイトルへ
     */
    protected async gotoTitle() {
        this.viewset();
        this.titleView.visible = true;
        this.titleView.initScenes();
        
    }

    /**
     * メニューへ
     */
    protected async gotoMenu() {
        this.viewset();
    }

    /**
     *　ランキングへ
     */
    protected async gotoRanking() {
        this.viewset();
    }

    /**
     *　図鑑へ
     */
    protected async gotoPictureBook() {
        this.viewset();
    }

    /**
     *　遊び方へ
     */
    protected async gotoHowto() {
        this.viewset();
    }

    /**
     *　各イベントを非表示にする
     */
    viewset() {
        this.titleView.visible = false;
        this.GameView.visible = false;
    }

    setParam() {
        GameQuizMain.api = new GameApi(GameQuizMain.GAME_ID, GameQuizMain.uuid);
    }

    //
    static setBanner (id) {
        //GameQuizMain.BannerContainer.removeAllChildren();
        //let img = GameQuizMain.resources[ GameQuizMain.BannerList[id] ]();
        //img.x = (GameQuizMain.stageWidth/2)-(600/2)
        //img.y = (GameQuizMain.stageHeight-160)+5
        //GameQuizMain.BannerContainer.addChild( img );

        for(let i=0; i<GameQuizMain.BannerList.length; i++) {
            if (id == i) {
                GameQuizMain.BannerList[i].img.visible = true;
            } else {
                GameQuizMain.BannerList[i].img.visible = false;
            }
        }
    }
    
}

// タイマー
export class BannerList {
    img: createjs.Sprite;
    file:string;
}

